export default __webpack_public_path__ + "static/media/02.c6bdfb05.jpg";